import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { connect } from 'react-redux';

import { IEventMonth, ICalendarState } from '@adage/ace-calendar';
import { ICalendar } from '@adage/calendar/services/calendar';

import ListMonth from '../components/list-month';
import GridMonth from '../components/grid-month';
import EmptyEvents from '../views/empty-events';

import { IWACEvent } from "../classes/event";
import { ICalendarReduxState } from "../classes/redux-state";

document.querySelectorAll("div");

interface DesktopContainerExternalProps {
    allMonths: Array<moment.Moment>;
    calendarMonths: Array<ICalendar<IWACEvent>>;
    evts: Array<IEventMonth<IWACEvent>>;
}

interface StateToProps {
    isGrid: boolean;
    isUpdating: boolean;
    lastMonthToDisplay: moment.Moment;
    endDate: moment.Moment;
}

interface DesktopContainerState {
}

type DesktopContainerProps = DesktopContainerExternalProps & StateToProps;

class DesktopContainer extends React.Component<DesktopContainerProps, DesktopContainerState> {
    /**
     * Lifecycle functions.
     * @param props
     */
    constructor(props: DesktopContainerProps) {
        super(props);
    }

    /**
     * Render function.
     */
    render() {
        return (
            <div className="desktop-container">
                {
                    this.props.evts.some(evt => evt.events.length > 0) || this.props.endDate.isBefore(this.props.lastMonthToDisplay) ?
                        this.props.isGrid ?
                            this.props.allMonths.map((monthMoment, idx) => <GridMonth key={`${monthMoment.format("MM,YYY")}-desktop`} monthMoment={monthMoment} eventMonth={this.props.calendarMonths[idx]} />) :
                            this.props.allMonths.map((monthMoment, idx) => <ListMonth key={`${monthMoment.format("MM,YYY")}-mobile`} monthMoment={monthMoment} eventMonth={this.props.calendarMonths[idx]} />)

                        :
                        <EmptyEvents />
                }
            </div>
        )
    }
}

function mapStateToProps(state: ICalendarReduxState) {
    return {
        isGrid: state.calendarModeModel.isGrid,
        isUpdating: state.calendarModel.updating,
        lastMonthToDisplay: state.calendarModeModel.lastDateToLoad,
        endDate: state.calendarModel.endDate
    }
}


export default connect<StateToProps>(mapStateToProps)(DesktopContainer);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/containers/desktop-container.tsx